module.exports = __webpack_public_path__ + "static/2-f634a11a2fd18eb3d0e3a7e802a5e1ba.jpeg";